import {BridgeType, resolveBridgeType, ResponseType} from './BridgeApi';
import socialLauncher from './launcher/social.launcher';
import socialWeb from './web/social.web';
import socialMock from './mock/social.mock';
import PresenceType from '../constants/PresenceType';

export interface Friend {
    appid: string;
    displayname: string;
    facebookname: string;
    friendid: string;
    hasvoicesupport: boolean;
    isjoinable: boolean;
    isonline: boolean;
    isplaying: boolean;
    onlinestatus: string;
    platform: string;
    playstationname: string;
    presence: PresenceType;
}

export type SocialResponseCallback = (friend: Friend, responseType: ResponseType) => void;

export interface SocialBridge {
    getFriendsList(): Promise<Friend[]>;
    getOnlineStatus(): Promise<PresenceType>;
    setStatusAway(): Promise<void>;
    setStatusOnline(): Promise<void>;
    openChat(friendId: string): Promise<void>;
    hasThirdPartyAccounts(thirdParty: string): Promise<boolean>;
    registerResponseCallback(callback: SocialResponseCallback): Promise<void>;
}

const bridges = {
    [BridgeType.LAUNCHER]: socialLauncher,
    [BridgeType.WEB]: socialWeb,
    [BridgeType.MOCK]: socialMock
};

export {PresenceType};
export default (): SocialBridge => bridges[resolveBridgeType()];
